import { Modal } from 'antd';
import { useState } from 'react';
import styles from './PopupButton.module.scss';
const PopupButton = ({
  name,
  title,
  embedHTML,
  color
}) => {
  const label = <span className={styles['popup-button-label']} children={title || name} />;
  const [open, setOpen] = useState(false);
  const iframe = <iframe allow="" sandbox="allow-scripts allow-same-origin" style={{
    width: '100%',
    aspectRatio: '16 / 9',
    border: '0 none transparent'
  }} srcDoc={embedHTML} />;
  return <>
      <button onClick={() => setOpen(true)} children={label} type="primary" style={{
      backgroundColor: color
    }} className={styles['popup-button']} />
      <Modal open={open} children={iframe} footer={null} width="80%" onCancel={() => setOpen(false)} destroyOnClose data-sentry-element="Modal" data-sentry-source-file="PopupButton.jsx" />
    </>;
};
export default PopupButton;